import RectLinear from '../rectLinear/';
import seriesableMixin from '../seriesable';
import brushableMixin from '../brushable';
import {setMethodsFromAttrs} from '../../modules/util';
import {filter} from '../default/muteRegions';
import _munge from './_munge';
import _scale from './_scale';
import _mark from './_mark';
import _axis from './_axis';
import _legend from './_legend';
import _region from './_region';
import _facet from './_facet';
import _brush from './_brush';

const size = {range: [1,1], scale: 'linear', reverse: false};
const shapes = ['par-coords', 'scatter-matrix'];
const conditions = ['normal', 'color'];
const _attrs = {
  regionPadding: 0.1,
  size: size,
  shape: shapes[0]
};

class ParCoords extends seriesableMixin(brushableMixin(RectLinear)) {
  constructor() {
    super(_attrs);
    this.brush(true);
  }
}

function _parCoords() {
  let parCoords =  new ParCoords();
  return parCoords;
}

function update() {
 // 데이터가 바뀐 경우

 // 데이터의 계산에 영향 주는 요소가 바뀐 경우

 // 다른 화면 요소가 바뀐 경우 
}

function isColor() {
  return this.condition() === conditions[1];
}

function highlight(selection, highlightColor) { //matrix 에서만 작동 
  selection.select('circle').style('fill', highlightColor)
    .style('stroke', highlightColor);
}

function dehighlight(selection) { //matrix 에서만 작동 
  selection.select('circle').style('fill', d => d.color)
    .style('stroke', d => d.color);
}

function highlightRegions(callback) { //TODO mute로 정의
  let _parCoords = region => {
    region.classed('highlight', true)
      .style('stroke', this.highlightColor());
  }
  let _matrix = region => {
    let nodes = region.selectAll(this.nodeName()).classed('highlight', true);
    nodes.call(highlight, this.highlightColor());
  }
  if (!arguments.length) {
    if (this.shape() === shapes[0]) {
      return this.filterRegions().call(_parCoords);
    } else {  
      return this.regions().selectAll(this.regionName())  
        .call(_matrix);
    }
  } 
  if (this.shape() === shapes[0]) {
    return this.filterRegions(callback).call(_parCoords);
  } else {
    return this.regions().selectAll(this.regionName()).filter(callback)
      .call(_matrix);
  }
}

function muteRegions(callback) { //TODO mute로 정의
  let _parCoords = region => {
    this.mute(region, this.muteIntensity());
  }
  let _matrix = region => {
    let nodes = region.selectAll(this.nodeName()).classed('mute', true);
    this.mute(nodes, this.muteIntensity());
  }
  if (!arguments.length) {
    if (this.shape() === shapes[0]) {
      return this.filterRegions().call(_parCoords);
    } else {  
      return this.regions().selectAll(this.regionName())  
        .call(_matrix);
    }
  } 
  if (this.shape() === shapes[0]) {
    return filter.call(this, callback).call(_parCoords);
  } else {
    return filter.call(this, callback, this.regions().selectAll(this.regionName()))
      .call(_matrix);
  }
}

function dehighlightRegions(callback) {
  let _parCoords = region => {
    region.classed('highlight', true)
      .style('stroke', d => d.color);
  }
  let _matrix = region => {
    let nodes = region.selectAll(this.nodeName());
    nodes.call(dehighlight);
  }
  if (!arguments.length) {
    if (this.shape() === shapes[0]) {
      return this.filterRegions().call(_parCoords);
    } else {  
      return this.regions().selectAll(this.regionName())  
        .call(_matrix);
    }
  }
  if (this.shape() === shapes[0]) {
    return this.filterRegions(callback).call(_parCoords);
  } else {
    return this.regions().selectAll(this.regionName()).filter(callback)
      .call(_matrix);
  }
}

function demuteRegions(callback) {
  let _parCoords = region => {
    this.demute(region);
  }
  let _matrix = region => {
    let nodes = region.selectAll(this.nodeName());
    this.demute(nodes);
  }
  if (!arguments.length) {
    if (this.shape() === shapes[0]) {
      return this.filterRegions().call(_parCoords);
    } else {  
      return this.regions().selectAll(this.regionName())  
        .call(_matrix);
    }
  }
  if (this.shape() === shapes[0]) {
    return filter.call(this, callback).call(_parCoords);
  } else {
    return filter.call(this, callback, this.regions().selectAll(this.regionName()))
      .call(_matrix);
  }
}

function muteFromLegend(legend) {
  this.muteRegions(d => d.data.key !== legend.key);
}

function demuteFromLegend(legend) {
  this.demuteRegions(d => d.data.key !== legend.key);
}

function renderLayout(keep) { //완벽히 처음부터 업데이트
  if (this.shape() === shapes[0] && this.axisX()) {
    let findIndex = this.__attrs__.axisToggle.findIndex(d => d.target === 'x');
    if (findIndex >= 0) {
      this.__attrs__.axisToggle.splice(findIndex, 1);
    }
  }
  this.reset(keep);
  this.renderFrame();
  _munge.call(this);
  _scale.call(this, keep);
  this.renderCanvas();
  _axis.call(this);
  if (this.shape !== shapes[0] || this.isColor()) _region.call(this);
  if (this.shape() === shapes[0]) {
    _mark.call(this); 
  } else {
    _facet.call(this);
  }
  
  _legend.call(this);
  _brush.call(this);
}
function xMeasureName (measure) {
  return 'x-' + (measure.field ? measure.field : measure);
}

function yMeasureName (measure) {
  return 'y-' + (measure.field ? measure.field : measure);
}

ParCoords.prototype.renderLayout = renderLayout;
ParCoords.prototype.update = update;
ParCoords.prototype.isColor = isColor;
ParCoords.prototype.highlight = highlight;
ParCoords.prototype.highlightRegions = highlightRegions;
ParCoords.prototype.muteRegions = muteRegions;
ParCoords.prototype.muteFromLegend = muteFromLegend;
ParCoords.prototype.dehighlight = dehighlight;
ParCoords.prototype.dehighlightRegions = dehighlightRegions;
ParCoords.prototype.demuteRegions = demuteRegions;
ParCoords.prototype.demuteFromLegend = demuteFromLegend;
setMethodsFromAttrs(ParCoords, _attrs);

export default _parCoords;
export {xMeasureName, yMeasureName, conditions, shapes};



// WEBPACK FOOTER //
// ./layouts/par-coords/index.js